// Featured Collections: product-card image hover zoom. Root element: [data-sw-fc-zoom] (one per section).
(function () {
  if (window.__swFeaturedCollectionsLoaded) return;
  window.__swFeaturedCollectionsLoaded = true;

  // Reduced motion: no zoom, images stay at their natural scale
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = '[data-sw-fc-zoom]';
  var instances = [];

  function init(section) {
    if (section.dataset.swInit) return; // guard against double init
    section.dataset.swInit = '1';

    var ctx = gsap.context(function () {
      section.querySelectorAll('.product-card__media').forEach(function (card) {
        var img = card.querySelector('.product-card__image--primary');
        if (!img) return;

        card.addEventListener('mouseenter', function () {
          gsap.killTweensOf(img);
          gsap.to(img, { scale: 1.06, duration: 0.5, ease: 'power2.out' });
        });

        card.addEventListener('mouseleave', function () {
          gsap.killTweensOf(img);
          gsap.to(img, { scale: 1, duration: 0.4, ease: 'power2.out' });
        });
      });
    }, section);

    instances.push({ el: section, destroy: function () { ctx.revert(); } });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var roots = e.target.querySelectorAll(SELECTOR);
    if (!roots.length) return;
    swGsap.load(function () { roots.forEach(init); }, { scrollTrigger: true });
  });

  document.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (inst) {
      if (e.target.contains(inst.el)) { inst.destroy(); return false; }
      return true;
    });
  });

  swGsap.load(initAll, { scrollTrigger: true });
})();
